var M = Object.defineProperty;
var D = (h, o, t) => o in h ? M(h, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : h[o] = t;
var P = (h, o, t) => (D(h, typeof o != "symbol" ? o + "" : o, t), t);
import { FirebaseError as F } from "firebase/app";
import { where as f, doc as l, runTransaction as m, getDoc as g, Timestamp as w, collection as y, getDocs as C, query as b, orderBy as v, startAfter as U, limit as B } from "firebase/firestore";
import { ref as E, getDownloadURL as S } from "firebase/storage";
import { DateTime as j } from "luxon";
function* x(h, o) {
  h !== null ? yield f("userId", "==", h) : yield f("isPublic", "==", !0), o !== void 0 && (o.brand !== null && (yield f("brand", "==", o.brand)), o.type !== null && (yield f("type", "==", o.type)), o.group !== null && (yield f("group", "==", o.group)), o.search !== null && (yield f("keywords", "array-contains", o.search.replace(/\s/g, ""))));
}
function* k(h) {
  const o = h.toLocaleLowerCase().replace(/\s/g, "");
  if (o.length === 0)
    return [];
  for (let t = 1; t < o.length; t++)
    for (let e = 0; e < o.length - t + 1; e++)
      yield o.substring(e, e + t);
  yield o;
}
const a = class a {
  static hash(o) {
    const t = a.sb(o);
    let e = 1732584193, r = -271733879, s = -1732584194, i = 271733878, c, u, d, p;
    for (let n = 0; n < t.length; n += 16)
      c = e, u = r, d = s, p = i, e = a.ff(e, r, s, i, t[n], 7, -680876936), i = a.ff(i, e, r, s, t[n + 1], 12, -389564586), s = a.ff(s, i, e, r, t[n + 2], 17, 606105819), r = a.ff(r, s, i, e, t[n + 3], 22, -1044525330), e = a.ff(e, r, s, i, t[n + 4], 7, -176418897), i = a.ff(i, e, r, s, t[n + 5], 12, 1200080426), s = a.ff(s, i, e, r, t[n + 6], 17, -1473231341), r = a.ff(r, s, i, e, t[n + 7], 22, -45705983), e = a.ff(e, r, s, i, t[n + 8], 7, 1770035416), i = a.ff(i, e, r, s, t[n + 9], 12, -1958414417), s = a.ff(s, i, e, r, t[n + 10], 17, -42063), r = a.ff(r, s, i, e, t[n + 11], 22, -1990404162), e = a.ff(e, r, s, i, t[n + 12], 7, 1804603682), i = a.ff(i, e, r, s, t[n + 13], 12, -40341101), s = a.ff(s, i, e, r, t[n + 14], 17, -1502002290), r = a.ff(r, s, i, e, t[n + 15], 22, 1236535329), e = a.gg(e, r, s, i, t[n + 1], 5, -165796510), i = a.gg(i, e, r, s, t[n + 6], 9, -1069501632), s = a.gg(s, i, e, r, t[n + 11], 14, 643717713), r = a.gg(r, s, i, e, t[n], 20, -373897302), e = a.gg(e, r, s, i, t[n + 5], 5, -701558691), i = a.gg(i, e, r, s, t[n + 10], 9, 38016083), s = a.gg(s, i, e, r, t[n + 15], 14, -660478335), r = a.gg(r, s, i, e, t[n + 4], 20, -405537848), e = a.gg(e, r, s, i, t[n + 9], 5, 568446438), i = a.gg(i, e, r, s, t[n + 14], 9, -1019803690), s = a.gg(s, i, e, r, t[n + 3], 14, -187363961), r = a.gg(r, s, i, e, t[n + 8], 20, 1163531501), e = a.gg(e, r, s, i, t[n + 13], 5, -1444681467), i = a.gg(i, e, r, s, t[n + 2], 9, -51403784), s = a.gg(s, i, e, r, t[n + 7], 14, 1735328473), r = a.gg(r, s, i, e, t[n + 12], 20, -1926607734), e = a.hh(e, r, s, i, t[n + 5], 4, -378558), i = a.hh(i, e, r, s, t[n + 8], 11, -2022574463), s = a.hh(s, i, e, r, t[n + 11], 16, 1839030562), r = a.hh(r, s, i, e, t[n + 14], 23, -35309556), e = a.hh(e, r, s, i, t[n + 1], 4, -1530992060), i = a.hh(i, e, r, s, t[n + 4], 11, 1272893353), s = a.hh(s, i, e, r, t[n + 7], 16, -155497632), r = a.hh(r, s, i, e, t[n + 10], 23, -1094730640), e = a.hh(e, r, s, i, t[n + 13], 4, 681279174), i = a.hh(i, e, r, s, t[n], 11, -358537222), s = a.hh(s, i, e, r, t[n + 3], 16, -722521979), r = a.hh(r, s, i, e, t[n + 6], 23, 76029189), e = a.hh(e, r, s, i, t[n + 9], 4, -640364487), i = a.hh(i, e, r, s, t[n + 12], 11, -421815835), s = a.hh(s, i, e, r, t[n + 15], 16, 530742520), r = a.hh(r, s, i, e, t[n + 2], 23, -995338651), e = a.ii(e, r, s, i, t[n], 6, -198630844), i = a.ii(i, e, r, s, t[n + 7], 10, 1126891415), s = a.ii(s, i, e, r, t[n + 14], 15, -1416354905), r = a.ii(r, s, i, e, t[n + 5], 21, -57434055), e = a.ii(e, r, s, i, t[n + 12], 6, 1700485571), i = a.ii(i, e, r, s, t[n + 3], 10, -1894986606), s = a.ii(s, i, e, r, t[n + 10], 15, -1051523), r = a.ii(r, s, i, e, t[n + 1], 21, -2054922799), e = a.ii(e, r, s, i, t[n + 8], 6, 1873313359), i = a.ii(i, e, r, s, t[n + 15], 10, -30611744), s = a.ii(s, i, e, r, t[n + 6], 15, -1560198380), r = a.ii(r, s, i, e, t[n + 13], 21, 1309151649), e = a.ii(e, r, s, i, t[n + 4], 6, -145523070), i = a.ii(i, e, r, s, t[n + 11], 10, -1120210379), s = a.ii(s, i, e, r, t[n + 2], 15, 718787259), r = a.ii(r, s, i, e, t[n + 9], 21, -343485551), e = a.ad(e, c), r = a.ad(r, u), s = a.ad(s, d), i = a.ad(i, p);
    return a.rh(e) + a.rh(r) + a.rh(s) + a.rh(i);
  }
  static rh(o) {
    let t = "";
    for (let e = 0; e <= 3; e++)
      t += a.alphabet.charAt(o >> e * 8 + 4 & 15) + a.alphabet.charAt(o >> e * 8 & 15);
    return t;
  }
  static ad(o, t) {
    const e = (o & 65535) + (t & 65535);
    return (o >> 16) + (t >> 16) + (e >> 16) << 16 | e & 65535;
  }
  static rl(o, t) {
    return o << t | o >>> 32 - t;
  }
  static cm(o, t, e, r, s, i) {
    return a.ad(a.rl(a.ad(a.ad(t, o), a.ad(r, i)), s), e);
  }
  static ff(o, t, e, r, s, i, c) {
    return a.cm(t & e | ~t & r, o, t, s, i, c);
  }
  static gg(o, t, e, r, s, i, c) {
    return a.cm(t & r | e & ~r, o, t, s, i, c);
  }
  static hh(o, t, e, r, s, i, c) {
    return a.cm(t ^ e ^ r, o, t, s, i, c);
  }
  static ii(o, t, e, r, s, i, c) {
    return a.cm(e ^ (t | ~r), o, t, s, i, c);
  }
  static sb(o) {
    let t;
    const e = (o.length + 8 >> 6) + 1, r = new Array(e * 16);
    for (t = 0; t < e * 16; t++)
      r[t] = 0;
    for (t = 0; t < o.length; t++)
      r[t >> 2] |= o.charCodeAt(t) << t % 4 * 8;
    return r[t >> 2] |= 128 << t % 4 * 8, r[e * 16 - 2] = o.length * 8, r;
  }
};
P(a, "alphabet", "0123456789abcdef");
let A = a;
class N {
  constructor(o, t) {
    this.firestore = o, this.firebaseStorage = t;
  }
  async createProject(o, t, e) {
    const r = await this.getUser(o), s = typeof (e == null ? void 0 : e.projectId) == "string" ? l(this.projectsCollection, e.projectId) : l(this.projectsCollection), i = l(
      this.projectBriefsCollection,
      s.id
    ), c = j.now().toMillis(), u = {
      id: s.id,
      userId: o,
      name: t ?? "New project",
      description: null,
      isPublic: !1,
      createdAt: c,
      updatedAt: c,
      brand: null,
      type: null,
      group: null,
      previews: null,
      preset: e !== void 0 ? {
        ...e,
        name: t ?? e.name,
        projectId: s.id
      } : null,
      lua: null
    };
    await m(this.firestore, async (p) => (p.set(s, u), p.set(i, {
      ...u,
      user: r,
      hasPreset: e !== void 0,
      hasLua: !1
    }), Promise.resolve()));
    const d = await g(s);
    if (!d.exists())
      throw new Error("failed to create new empty project");
    return d.data();
  }
  async getProject(o) {
    const t = await g(l(this.projectsCollection, o));
    if (!t.exists())
      throw new Error(`Project with ID=${o} not found`);
    return t.data();
  }
  async updateProject(o) {
    const t = {
      ...o,
      updatedAt: j.now().toMillis()
    }, e = await this.getUser(o.userId);
    return await m(this.firestore, async (r) => {
      var s;
      return r.set(l(this.projectsCollection, o.id), t), r.set(l(this.projectBriefsCollection, o.id), {
        ...t,
        user: e,
        hasPreset: typeof o.preset == "string" && o.preset.length > 0 || o.preset !== null,
        hasLua: o.lua !== null && ((s = o.lua) == null ? void 0 : s.length) > 0
      }), Promise.resolve();
    }), await this.getProject(o.id);
  }
  async patchProject(o, t, e) {
    const r = w.fromMillis(Date.now());
    await m(this.firestore, async (s) => {
      switch (t) {
        case "name":
        case "description":
        case "isPublic":
        case "brand":
        case "type":
        case "group":
        case "previews": {
          s.update(l(this.projectsCollection, o), {
            updatedAt: r,
            [t]: e
          }), s.update(l(this.projectBriefsCollection, o), {
            updatedAt: r,
            [t]: e
          });
          break;
        }
        case "preset":
        case "lua": {
          s.update(l(this.projectsCollection, o), {
            updatedAt: r,
            [t]: e
          });
          break;
        }
      }
      return Promise.resolve();
    });
  }
  async deleteProject(o) {
    await m(this.firestore, (t) => {
      const e = l(this.projectsCollection, o), r = l(this.projectBriefsCollection, o);
      return t.delete(e), t.delete(r), Promise.resolve();
    });
  }
  async getProjectBrief(o) {
    const t = await g(l(this.projectBriefsCollection, o));
    return t.exists() ? t.data() : null;
  }
  getPrivateProjectBriefs(o, t, e, r) {
    return this.getProjectBriefs(o, t, e, r);
  }
  getPublicProjectBriefs(o, t, e) {
    return this.getProjectBriefs(null, o, t, e);
  }
  async getProjectPagePreviewUrl(o, t) {
    try {
      const e = E(
        this.firebaseStorage,
        `previews/${o}-${t}.svg`
      );
      return await S(e);
    } catch (e) {
      if (e instanceof F && e.code === "storage/object-not-found")
        return null;
      throw e;
    }
  }
  getUserAvatarUrl(o) {
    const t = A.hash(o.email);
    return Promise.resolve(
      `https://secure.gravatar.com/avatar/${t}?size=80&d=robohash`
    );
  }
  async copyProject(o, t) {
    const e = await this.getProject(t), r = l(this.projectsCollection);
    if (typeof e.preset == "string")
      throw new Error("unable to make copy of malformed preset");
    const s = j.now().toMillis();
    return await this.updateProject({
      ...e,
      id: r.id,
      isPublic: !1,
      userId: o,
      createdAt: s,
      preset: e.preset !== null ? {
        ...e.preset,
        projectId: r.id
      } : null
    });
  }
  get projectsCollection() {
    return y(this.firestore, "e4.projects").withConverter({
      toFirestore: (o) => ({
        ...o,
        preset: o.preset !== null ? typeof o.preset != "string" ? JSON.stringify(o.preset) : o.preset : null,
        createdAt: w.fromMillis(o.createdAt),
        updatedAt: w.fromMillis(o.updatedAt)
      }),
      fromFirestore: (o) => {
        if (o.exists()) {
          const t = o.data();
          try {
            return {
              ...t,
              preset: t.preset !== null ? JSON.parse(t.preset) : null,
              createdAt: t.createdAt.toMillis(),
              updatedAt: t.updatedAt.toMillis()
            };
          } catch (e) {
            return console.error(e), {
              ...t,
              preset: t.preset,
              createdAt: t.createdAt.toMillis(),
              updatedAt: t.updatedAt.toMillis()
            };
          }
        }
        throw new Error("todo: handle non-existing documents");
      }
    });
  }
  get projectBriefsCollection() {
    return y(this.firestore, "e4.project-briefs").withConverter({
      toFirestore: (o) => ({
        ...o,
        keywords: Array.from(k(o.name)),
        createdAt: w.fromMillis(o.createdAt),
        updatedAt: w.fromMillis(o.updatedAt)
      }),
      fromFirestore: (o) => {
        if (o.exists()) {
          const t = o.data();
          return {
            ...t,
            createdAt: t.createdAt.toMillis(),
            updatedAt: t.updatedAt.toMillis()
          };
        }
        throw new Error("todo: handle non-existing documents");
      }
    });
  }
  get usersCollection() {
    return y(this.firestore, "users").withConverter({
      toFirestore: (o) => o,
      fromFirestore: (o) => {
        if (o.exists())
          return o.data();
        throw new Error("todo: handle non-existing documents");
      }
    });
  }
  async getProjectBriefs(o, t, e, r) {
    const s = Array.from(x(o, r));
    if (e !== void 0) {
      const c = await g(l(this.projectBriefsCollection, e));
      return (await C(
        b(
          this.projectBriefsCollection,
          ...s,
          v("updatedAt", "desc"),
          U(c),
          B(t)
        )
      )).docs.map((d) => d.data());
    }
    return (await C(
      b(
        this.projectBriefsCollection,
        ...s,
        v("updatedAt", "desc"),
        B(t)
      )
    )).docs.map((c) => c.data());
  }
  async getUser(o) {
    const t = await g(l(this.usersCollection, o));
    if (!t.exists())
      throw new Error(`User with ID=${o} not found`);
    return t.data();
  }
}
export {
  N as FirebaseElectraStorage,
  k as makeKeywords
};
//# sourceMappingURL=index.js.map
